// eslint-disable-next-line
const { observable, computed, action, makeObservable } = require('mobx');

class Store {
  MASKED_CC_PREFIX = '************';

  checkout;

  endDigits;

  selectedMethod = '';

  componentsObj = {};

  checkoutConfiguration = window.Configuration || {};

  paymentMethodsConfiguration = {};

  formErrorsExist;

  isValid = false;

  paypalTerminatedEarly = false;

  componentState = {};

  brand;

  partialPaymentsOrderObj;

  giftCardComponentListenersAdded;

  addedGiftCards;

  fastlane = {};

  constructor() {
    makeObservable(this, {
      checkout: observable,
      endDigits: observable,
      selectedMethod: observable,
      componentsObj: observable,
      checkoutConfiguration: observable,
      paymentMethodsConfiguration: observable,
      formErrorsExist: observable,
      isValid: observable,
      paypalTerminatedEarly: observable,
      componentState: observable,
      brand: observable,
      partialPaymentsOrderObj: observable,
      giftCardComponentListenersAdded: observable,
      addedGiftCards: observable,
      fastlane: observable,
      maskedCardNumber: computed,
      selectedPayment: computed,
      selectedPaymentIsValid: computed,
      stateData: computed,
      updateSelectedPayment: action,
      clearPaymentMethod: action,
    });
  }

  get maskedCardNumber() {
    return `${this.MASKED_CC_PREFIX}${this.endDigits}`;
  }

  get selectedPayment() {
    return this.componentsObj[this.selectedMethod];
  }

  get selectedPaymentIsValid() {
    return !!this.selectedPayment?.isValid;
  }

  get stateData() {
    return (
      this.selectedPayment?.stateData || {
        paymentMethod: {
          type: this.selectedMethod,
          ...(this.brand ? { brand: this.brand } : undefined),
        },
      }
    );
  }

  updateSelectedPayment(method, key, val) {
    if (!this.componentsObj[method]) {
      this.componentsObj[method] = {};
    }
    this.componentsObj[method][key] = val;
  }

  clearPaymentMethod() {
    this.componentsObj = {};
    this.selectedMethod = '';
  }
}

module.exports = new Store();
